const INITIAL_STATE = {
  user: null,
  signedIn: null,
};

const googleAuthReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_USER":
      return { ...state, user: action.payload };
    case "CREATE_USER":
      return { ...state, user: action.payload };
    case "UPDATE_USER":
      return { ...state, user: action.payload };
    case "SIGN_IN":
      return { ...state, signedIn: true };
    case "SIGN_OUT":
      return { ...state, signedIn: false };
    default:
      return state;
  }
};

export default googleAuthReducer;
